import { ref } from 'vue';
import RealEstateBrokerCommissionTransfersAPI from 'dashboard/api/realEstateBrokerCommissionTransfers';
import RealEstateFinanceCompanyTransfersAPI from 'dashboard/api/realEstateFinanceCompanyTransfers';

export function useRealEstateFinanceTransferReceipts({
  notify,
  t = key => key,
}) {
  const loadingTransferId = ref(null);

  const downloadTransferReceipt = async transfer => {
    if (!transfer?.id || !transfer.comprovante?.pode_baixar) return null;

    loadingTransferId.value = transfer.id;
    try {
      const api =
        transfer.beneficiario?.tipo === 'empresa'
          ? RealEstateFinanceCompanyTransfersAPI
          : RealEstateBrokerCommissionTransfersAPI;
      const response = await api.downloadReceipt(transfer.id);
      const url = response.data?.data?.url;
      if (url) window.open(url, '_blank', 'noopener,noreferrer');
      return url || null;
    } catch (error) {
      const message =
        error.response?.data?.message ||
        t('REAL_ESTATE_FINANCE.ERRORS.OPERATION');
      if (notify) notify(message, 'error');
      throw error;
    } finally {
      loadingTransferId.value = null;
    }
  };

  return { downloadTransferReceipt, loadingTransferId };
}
